import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { WebUI, getNid } from "../../wui-core/src/index";
import { AnchorLinkProps } from './iAnchor';
import Icon from '../../wui-icon/src';

const defaultProps = {
    prefixCls: 'wui-anchor',
    href: '',
    target: '',
    title: null
};

const AntdAnchorLink: React.FC<AnchorLinkProps> = (incomingProps) => {
    // ==================== Props ====================
    const props = { ...defaultProps, ...incomingProps };
    const {
        prefixCls, href, title, children, className, target,
        expanded, fieldid, isdirection, activeIcon, onSelect
    } = props;

    // ==================== 事件处理 ====================
    const handleClick = useCallback((value: {href: string, title: any}, e: React.MouseEvent) => {
        e.preventDefault();
        if (!value.href) {
            return;
        }

        onSelect?.(value, e);
    }, [onSelect]);

    // ==================== 渲染图标 ====================
    const renderIcon = useMemo(() => {
        if (!isdirection) return null;

        return (
            <div className={`${prefixCls}-line-dotted-box`}>
                <div className={`${prefixCls}-line-dotted`}></div>
                {expanded ? (activeIcon || <Icon type="uf-yuandian" />) : null}
            </div>
        );
    }, [isdirection, expanded, activeIcon, prefixCls]);

    // ==================== 样式类名 ====================
    const wrapperClassName = classNames(
        `${prefixCls}-link`,
        {
            [`${prefixCls}-link-active`]: expanded,
        },
        className,
    );

    const titleClassName = classNames(`${prefixCls}-link-title`, {
        [`${prefixCls}-link-title-active`]: expanded,
    });

    // ==================== 适配器 NID ====================
    const adapterNid = getNid(props);

    // ==================== 渲染 ====================
    return (
        <div className={wrapperClassName} {...adapterNid}>
            {renderIcon}
            <a
                className={titleClassName}
                href={href}
                title={typeof title === 'string' ? title : ''}
                target={target}
                onClick={(e) => handleClick({ href, title }, e)}
                fieldid={fieldid ? `${fieldid}-anchorLink-${href}` : undefined}
            >
                {title}
            </a>
            {children}
        </div>
    );
};

export default WebUI({ name: "anchor", defaultProps })(AntdAnchorLink);
